import React from 'react'
import "./Nftopen.css"
import nfto from "../Assets/nfto.gif"
import nftop from "../Assets/nftop.gif"
import nftope from "../Assets/nftope.gif"
function Nftopen() {
    return (
        <div className='nft_op_main'>
            <div className="container nft_bg">
                <div className="row reverse">
                    <div className="col-xl-7 col-12 col-md-12">
                        <div className="grp">
                            <div className="leeft">
                                <div>
                                    <img className="item iteem" src={nfto} alt="" />
                                </div>
                            </div>
                            <div className="rightt">
                                <div>
                                    <img src={nftop} className="item iteem" alt="" />
                                </div>
                                <div>
                                    <img className="iteem item  mb-3 mt-4" src={nftope} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-5">
                        <h4 className="white text-start ps-2">Open NFT Market</h4>
                        <br />
                        <p className="NFTpara">NFT marketplace where users may purchase and sell digital assets with crypto or fiat, as well as buy and sell non-fungible tokens (NFTs) on the blockchain.</p>
                        <p className="NFTpara lh-0">A non-fungible token (NFT) is a unit of data stored on a digital ledger (a blockchain) that certifies a digital asset to be unique and therefore not interchangeable. </p>
                        <p className="NFTpara lh-0">A decentralised NFT marketplace, MnftSwap open NFT market aims to be the most user-friendly and interoperable NFT platform that pays its holders. With MnftSwap Open NFT Market, you can exchange NFT inventions for cash. To increase your profits, establish your own prices.We aim to create a global digital decentralized network with a specialization in the transfer of digital assets </p>
                        <p className="NFTpara lh-0">If you want to get in on the NFT frenzy, an NFT marketplace is your ticket to buying and selling digital goods ranging from art to music to entire virtual worlds. Consider NFT marketplaces to be the Amazon of the digital world. </p>
                        <p className="NFTpara lh-0">Mnft Open NFT Market also users to create digital assets in the form of Non-Fungible Tokens (NFTs), trade them on the marketplace, and receive rewards in decentralized format.MnftSwap Open NFT market is an established non-fungible token (NFT) game studio, marketplace with 10+ games, a 20000+ community, and top 5 NFT marketplace volume.MnftSwap aims to provide a complete trading environment that addresses every aspect of DeFi. </p>
                        <p className="NFTpara lh-0">MnftSwap's NFT Marketplace will be a market leader in NFT sales. MnftSwap's platform offers a wide range of digital assets available, and it's free to sign up and peruse the broad options. It also helps artists and creators and includes a simple approach for creating your own NFT. </p>
                        <p className="NFTpara lh-0">Vision Of MnftSwap about its NFT market place it to establish itself as the go-to platform for any user or brand to interact with NFT content and to realise the full economic potential of NFTs for all digital assets across all marketplaces and blockchains. </p>

                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <h4 className='white text-start ps-2'>Vision</h4>
                        <p className='para'>Vision Of MnftSwap about its NFT market place it to establish itself as the go-to platform for any user or brand to interact with NFT content and to realise the full economic potential of NFTs for all digital assets across all marketplaces and blockchains.</p>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Nftopen
